import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import LogoTiles from '@segment/templates/LogoTiles'
import DividerSection from '@segment/templates/DividerSection'

import { TilesGridWrapper } from '@segment/templates/LogoTiles/LogoTiles.views'

import Layout from '@segment/next-shared/layout'

import BecomeSegmentSelect from './components/BecomeSegmentSelect'
import PartnersSelect from './components/PartnersSelect'
import AlreadyAPartner from './components/AlreadyPartner'
import LookingForPartner from './components/LookingForPartner'

import ogImage from './assets/OgPartnersMain.jpg'

const copy = {
  pageTitle: `Become a Twilio Segment Partner | Twilio Segment`,
  pageDescription: `Join our trusted network of Twilio Segment digital consultants, agencies, and technology partners to grow your business while providing exceptional service to our joint customers.`,
}

const PartnersView: FC<PropsWithChildren<unknown>> = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle={copy.pageTitle} pageDescription={copy.pageDescription} pageOG={ogImage}>
        <NavigationV2 />
        <main>
          <BecomeSegmentSelect />
          <PartnersSelect />
          <AlreadyAPartner />
          <DividerSectionWrapper>
            <DividerSection />
          </DividerSectionWrapper>
          <LookingForPartner />
          <LogoWrapper>
            <LogoTiles />
          </LogoWrapper>
        </main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const LogoWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
  ${TilesGridWrapper} {
    max-width: 100%;
  }
`

const DividerSectionWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 24px;
    padding-bottom: 24px;
  }
`

export default PartnersView
